














































import {Vue, Component, Provide} from 'vue-property-decorator';
import IGlobalSetting from '@/models/globalsetting';
import {mapActions} from 'vuex';
import {API} from '@/services/api/api';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class GlobalSetting extends Vue {
  header = [
    {name: 'Mail From', bindClass: 'width-fix'},
    {name: 'Mail Server Address', bindClass: 'width-fix'},
    {name: 'User ID', bindClass: ''},
    {name: 'Port Number', bindClass: ''},
    {name: 'ReInsp Low', bindClass: ''},
    {name: 'ReInsp Medium', bindClass: ''},
    {name: 'ReInsp High', bindClass: ''},
    {name: 'ReInsp Must See', bindClass: ''},
  ];

  //Loader and helper vairables
  showErrorToast: any;
  isScreenLoading = true;

  globalSettingData: IGlobalSetting[] = [];

  mounted() {
    this.getGlobalSetting();
  }

  //fetch list from api
  async getGlobalSetting() {
    try {
      let response = await API.getGlobalSetting();
      this.isScreenLoading = false;
      if (response.data !== '' && response.data !== null) {
        let list: IGlobalSetting[] = response.data;

        this.globalSettingData = list;
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.isScreenLoading = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  clickOnEdit(settingId) {
    this.$router.push('/edit-global-setting');
  }
}
